<template>
  <pipeline-management />
</template>

<script>
import PipelineManagement from "@/components/3pl/CRM/PipelineManagement/PipelineManagement";
export default {
  components: {
    PipelineManagement,
  },
};
</script>

<style></style>
